import SliderHome from './SliderHome'
export default SliderHome
